<template>
  <VDialog v-model="dialogModel" max-width="360" persistent>
    <VCard class="about-dialog">
      <VCardText class="text-center pa-6">
        <img
          src="/images/logo/logo.svg"
          alt="Starvly"
          class="about-logo mb-4"
        />

        <h2 class="text-h5 font-weight-bold mb-1">{{ productInfo.posProductName }}</h2>
        <p class="text-body-2 text-disabled mb-4">Version {{ productInfo.posProductVersion }}</p>

        <VDivider class="mb-4" />

        <div class="text-left">
          <div class="d-flex justify-space-between mb-2">
            <span class="text-caption text-disabled">Vendor</span>
            <span class="text-caption font-weight-medium">{{ productInfo.posProductVendor }}</span>
          </div>
          <div class="d-flex justify-space-between mb-2">
            <span class="text-caption text-disabled">Product</span>
            <span class="text-caption font-weight-medium">{{ productInfo.posProductName }}</span>
          </div>
          <div class="d-flex justify-space-between mb-2">
            <span class="text-caption text-disabled">Version</span>
            <span class="text-caption font-weight-medium">{{ productInfo.posProductVersion }}</span>
          </div>
        </div>

        <VDivider class="my-4" />

        <p class="text-caption text-disabled mb-0">
          &copy; {{ new Date().getFullYear() }} Starvly Pty Ltd. All rights reserved.
        </p>
      </VCardText>

      <VCardActions class="justify-center pb-4">
        <VBtn color="primary" variant="flat" @click="dialogModel = false">
          Close
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script setup>
import { version } from '../../package.json'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const dialogModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const productInfo = {
  posProductVendor: 'Starvly',
  posProductName: 'Starvly POS',
  posProductVersion: version,
}
</script>

<style scoped>
.about-dialog {
  border-radius: 16px;
}

.about-logo {
  width: 120px;
  height: auto;
}
</style>
